import { axiosApi, basePath } from "./api";

//获取销售部门
export function getDepartments (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/sales/departments/report/tree', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
}
//获取销售顾问
export function getEmployee (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/sales/employee/app/selectLeaderUnderling', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
}

//获取销售顾问
export function getManagerInfo (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/sales/managerSale/selectList', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
}




//获取拜访提醒
export function getVisitSignList (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/sales/visitSign/notice/page', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
}

//拜访记录下载图片压缩包
export function getZip (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/sales/visitSign/picture/zipExport', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
}

//拜访统计
export function getStatistics (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/sales/visitSign/statistics', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
}

